import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white shadow-md'
          : 'bg-black/25 backdrop-blur-sm border-b border-white/10'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-12 py-4 sm:py-5">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img
              src="https://public.readdy.ai/ai/img_res/b59b4674-bc57-4633-8a18-84255c1c1687.png"
              alt="True Passage Ventures"
              className="h-14 sm:h-16 w-auto mix-blend-lighten"
            />
            <span className={`text-lg sm:text-xl font-bold ${isScrolled ? 'text-navy-primary' : 'text-white'}`}>
              True Passage
            </span>
          </Link>

          {/* Desktop Navigation - Right aligned */}
          <div className="hidden lg:flex items-center gap-8">
            <Link
              to="/"
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-navy-primary hover:text-gold-accent' : 'text-white hover:text-gold-accent'
              }`}
            >
              Home
            </Link>
            <Link
              to="/about"
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-navy-primary hover:text-gold-accent' : 'text-white hover:text-gold-accent'
              }`}
            >
              About Us
            </Link>
            <Link
              to="/services"
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-navy-primary hover:text-gold-accent' : 'text-white hover:text-gold-accent'
              }`}
            >
              Services
            </Link>
            <Link
              to="/products"
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-navy-primary hover:text-gold-accent' : 'text-white hover:text-gold-accent'
              }`}
            >
              Products
            </Link>
            <Link
              to="/ai-tools"
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-navy-primary hover:text-gold-accent' : 'text-white hover:text-gold-accent'
              }`}
            >
              AI Tools
            </Link>
            <Link
              to="/blog"
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-navy-primary hover:text-gold-accent' : 'text-white hover:text-gold-accent'
              }`}
            >
              Blog
            </Link>
            <Link
              to="/request-quote"
              className="px-6 py-2.5 bg-gold-accent text-navy-primary rounded-full font-semibold hover:scale-[1.02] transition-transform whitespace-nowrap cursor-pointer"
            >
              Get Quote
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isScrolled ? 'text-navy-primary' : 'text-white'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 py-4 border-t border-navy-primary/10">
            <div className="flex flex-col gap-4">
              <Link
                to="/"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`font-medium transition-colors cursor-pointer ${
                  isScrolled ? 'text-navy-primary hover:text-gold-accent' : 'text-white hover:text-gold-accent'
                }`}
              >
                Home
              </Link>
              <Link
                to="/about"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`font-medium transition-colors cursor-pointer ${
                  isScrolled ? 'text-navy-primary hover:text-gold-accent' : 'text-white hover:text-gold-accent'
                }`}
              >
                About Us
              </Link>
              <Link
                to="/services"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`font-medium transition-colors cursor-pointer ${
                  isScrolled ? 'text-navy-primary hover:text-gold-accent' : 'text-white hover:text-gold-accent'
                }`}
              >
                Services
              </Link>
              <Link
                to="/products"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`font-medium transition-colors cursor-pointer ${
                  isScrolled ? 'text-navy-primary hover:text-gold-accent' : 'text-white hover:text-gold-accent'
                }`}
              >
                Products
              </Link>
              <Link
                to="/ai-tools"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`font-medium transition-colors cursor-pointer ${
                  isScrolled ? 'text-navy-primary hover:text-gold-accent' : 'text-white hover:text-gold-accent'
                }`}
              >
                AI Tools
              </Link>
              <Link
                to="/blog"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`font-medium transition-colors cursor-pointer ${
                  isScrolled ? 'text-navy-primary hover:text-gold-accent' : 'text-white hover:text-gold-accent'
                }`}
              >
                Blog
              </Link>
              <Link
                to="/request-quote"
                onClick={() => setIsMobileMenuOpen(false)}
                className="px-6 py-2.5 bg-gold-accent text-navy-primary rounded-full font-semibold hover:scale-[1.02] transition-transform whitespace-nowrap cursor-pointer text-center"
              >
                Get Quote
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;